import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { penStudyFlowsActions } from 'features/penStudyFlows';

const usePenStudyFlows = () => {
  const dispatch = useDispatch();
  const getPenStudyFlow = useCallback(() => dispatch(penStudyFlowsActions.getPenStudyFlow()), [dispatch]);
  const createPenStudyFlow = useCallback(pen_study_flow => dispatch(penStudyFlowsActions.createPenStudyFlow(pen_study_flow)), [dispatch]);
  const updatePenStudyFlow = useCallback(pen_study_flow => dispatch(penStudyFlowsActions.updatePenStudyFlow(pen_study_flow)), [dispatch]);
  const deletePenStudyFlow = useCallback(() => dispatch(penStudyFlowsActions.deletePenStudyFlow()), [dispatch]);
  const clearLocalActivePenStudyFlow = useCallback(() => dispatch(penStudyFlowsActions.clearLocalActivePenStudyFlow()), [dispatch]);

  return {
    getPenStudyFlow,
    createPenStudyFlow,
    updatePenStudyFlow,
    deletePenStudyFlow,
    clearLocalActivePenStudyFlow
  };
};

export default usePenStudyFlows;